import { Component } from '@angular/core';
import { AdminEditableBaseComponent } from '../admin-editable-base.component';

@Component({
  selector: 'thema-core-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
})
export class ContactComponent extends AdminEditableBaseComponent {}
